import React, { Component } from "react";
import CategorySelectionList from "./category_selection_list";

class CategorySelection extends Component {
  state = { showAll: false };
  render() {
    if (this.state.showAll === true) {
      return (
        <CategorySelectionList
          categories={this.props.categories}
          showAllCategories={this.showAllCategories}
          selectCategory={this.selectCategory}
        />
      );
    }
    if (this.props.category == null) {
      return (
        <div
          style={{ cursor: "pointer" }}
          className="list_category_v2 list_category_v2_not_selected"
          onClick={this.showAllCategories}
        >
          #Select
        </div>
        // <div
        //   className="category cursor_btn margin-top-1"
        //   onClick={this.showAllCategories}
        // >
        //   <div className="category_row">
        //     <label className="hashtag hashtag_padding cursor_btn">#</label>
        //     <label className="hashtag category_name cursor_btn">Select</label>
        //   </div>
        // </div>
      );
    }
    return (
      <div
        style={{ cursor: "pointer" }}
        className="list_category_v2"
        onClick={this.showAllCategories}
      >
        #{this.props.category.name}
      </div>
      // <div
      //   className="category cursor_btn margin-top-1"
      //   onClick={this.showAllCategories}
      // >
      //   <div className="category_row">
      //     <label className="hashtag hashtag_padding cursor_btn">#</label>
      //     <label className="category_name cursor_btn">
      //       {this.props.category.name}
      //     </label>
      //   </div>
      // </div>
    );
  }

  showAllCategories = e => {
    const showAll = !this.state.showAll;
    this.setState({ showAll });
  };

  selectCategory = category => {
    const showAll = false;
    this.setState({ showAll });
    this.props.selectCategory(category);
  };
}

export default CategorySelection;



// WEBPACK FOOTER //
// ./src/components/categories/category_selection.jsx